import React, { FC, useState } from 'react'

import VKIcon from '../../../public/static/icons/vk.svg'
import LinkIcon from '../../../public/static/icons/link.svg'
import TelegramIcon from '../../../public/static/icons/telegram.svg'
import css from './Share.module.scss'
import { CopyToClipboard } from 'react-copy-to-clipboard'

interface IShare {
  link: string
}

const Share: FC<IShare> = ({ link }) => {
  const [copied, setCopied] = useState(false)
  const copyLink = () => {
    setCopied(true)

    setTimeout(() => setCopied(false), 3000)
  }
  return (
    <div className={css.share}>
      <h5 className={css.heading}>Поделиться</h5>
      <ul className={css.text}>
        <li>
          <a
            href={`https://vk.com/share.php?url=${link}`}
            className={css.share_link}
            target="_blank"
            rel="noreferrer"
          >
            <VKIcon />
          </a>
        </li>

        <li>
          <a
            className={css.share_link}
            href={`https://telegram.me/share/url?url=${link}`}
            target="_blank"
            rel="noreferrer"
          >
            <TelegramIcon />
          </a>
        </li>
        <li>
          <CopyToClipboard text={link} onCopy={() => copyLink()}>
            <button type="button" className={css.share_link}>
              <LinkIcon />
            </button>
          </CopyToClipboard>
        </li>
      </ul>

      {copied && <div className={css.tooltip}>Ссылка скопирована</div>}
    </div>
  )
}

export default Share
